import React from 'react';
import classNames from 'classnames/bind';
import { number, oneOfType, shape, string } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { StorePin } from '../StorePin/StorePin';
import { storeShape } from '../storeShape';
import styles from './store-map-preview.module.scss';

const cx = classNames.bind(styles);

const MAP_KEY = 'AoKTFnu3hdkRgVWl45fcxdz0WSDP6hroMDcPKXE4ZkQql3hPt3PtkCDwtNRCYgYA';

const StoreMapPreview = ({ className, mapOptions, store }) => {
  const mapOptionsMerged = { ...StoreMapPreview.defaultProps.mapOptions, ...mapOptions };

  const { height: mapHeight, width: mapWidth, zoom } = mapOptionsMerged || {};
  const { address, coordinates } = store || {};
  const { street, city, state, postalCode } = address || {};
  const { lat, lng } = coordinates || {};

  if (!address || !coordinates) return null;

  const bingMapURL = `https://www.bing.com/mapspreview?where1=${street}, ${city}, ${state} ${postalCode}&sty=c`;
  const bingMapSrcQueries = `${lat},${lng}/${zoom}?mapSize=${mapWidth},${mapHeight}&key=${MAP_KEY}`;
  const bingMapSrc = `https://dev.virtualearth.net/REST/v1/Imagery/Map/Road/${bingMapSrcQueries}`;

  return (
    <div data-testid="store-map-preview" className={cx('store-map-preview', className)}>
      <a rel="nofollow noreferrer" target="_blank" href={bingMapURL}>
        <div className={cx('store-map-preview__inner-wrapper')}>
          <div className={cx('store-map-preview__pin')}>
            <StorePin mini />
          </div>
          <Image
            alt="map preview"
            height={mapHeight}
            width={mapWidth}
            src={bingMapSrc}
          />
        </div>
      </a>
    </div>
  );
};

StoreMapPreview.propTypes = {
  className: string,
  mapOptions: shape({
    height: oneOfType([string, number]),
    width: oneOfType([string, number]),
    zoom: oneOfType([string, number])
  }),
  store: storeShape
};

StoreMapPreview.defaultProps = {
  className: null,
  mapOptions: {
    height: '100',
    width: '100',
    zoom: '13'
  },
  store: {}
};

StoreMapPreview.displayName = 'StoreMapPreview';

export { StoreMapPreview };
